<template>
  <div>
    <iframe
      v-if="showIframe"
      frameborder="0"
      width="100%"
      style="z-index: 10; height:calc(100vh - 111px);"
      title="Báo cáo thống kê"
      :src="urlIframe"
    ></iframe>
    <a :href="urlIframe" target="_blank" rel="noopener noreferrer"></a>
  </div>
</template>
<script>
import DDATApi from "@/moduleApi/DDATApi";
import MethodService from '../../../service/MethodService'
import LanguageService from '../../../service/LanguageService'
import config from "../../../config.json";

export default {
  data() {
    return {
      urlIframe: undefined,
      urlPrefix: 'https://thongke.tourism.vn/baocao',
      showIframe: false,
      currentUser: MethodService.getCurrentUser(),
      dataForm: undefined
    }
  },
  methods: {
    fn_openReport(redirectRouteName) {
      try {
        const tokenApp = encodeURIComponent(localStorage.getItem("mushroom.tokens[" + config.hostApiTrangVang + "api/v1/" + "]"))
        this.urlIframe = `${this.urlPrefix}?token=${tokenApp}`
        let ele = document.createElement('a')
        ele.setAttribute('href', this.urlIframe)
        ele.setAttribute('target', '_blank')
        ele.click()
        this.$router.push({
          name: redirectRouteName
        })
      } catch (error) {
        console.log('error', error);
      }
    },
    async getDataSafaplace() {
      const resApi = await DDATApi.list({
        filters: "nguoi_tao_id=" + this.currentUser.id
      })
      if (resApi.result && resApi.result.length > 0) {
        this.dataForm = resApi.result[0]
        const dataSafePlace = resApi.result[0] ? resApi.result[0].du_lieu_khai_bao : {}
        if (
          dataSafePlace.user_ten &&
          dataSafePlace.user_dia_chi &&
          dataSafePlace.user_so_giay_to &&
          dataSafePlace.email &&
          dataSafePlace.user_loai
        ) {
          if (('hotel,tourist_villa,tourist_apartment,tourist_cruise,motel,homestay,camping'.includes(dataSafePlace.user_loai))) return !!dataSafePlace.khach_san_so_sao
          else return true
        }
        return false
      }
    },
    async showAleart() {
      if (!await this.getDataSafaplace()) {
        this.$confirm(
          "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
          {
            confirmButtonText: LanguageService.lang.c_agree,
            showClose: false,
            showCancelButton: false,
            type: "warning",
          }
        )
        .then(() => {
          this.$router.push({
            name: "Admin-ThongTinDDAT-update",
            params: { id: this.dataForm.id },
          })
        })
      } else {
        this.fn_openReport("Admin-ThongTinDDAT-detail")
      }
    }
  },
  created() {
    if (this.currentUser.roles.indexOf("TourAgent") != -1) {
      this.fn_openReport("Admin-Home")
    } else {
      this.showAleart()
    }
  },
}
</script>
<style lang="">

</style>
